import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_LIQUID_CASHBACK_IFRAME_URL = createRequestTypes('GET_LIQUID_CASHBACK_IFRAME_URL');
export const getLiquidCashbackIframeUrl = {
  request: () => action(GET_LIQUID_CASHBACK_IFRAME_URL[REQUEST]),
  success: data => action(GET_LIQUID_CASHBACK_IFRAME_URL[SUCCESS], { data }),
  failure: error => action(GET_LIQUID_CASHBACK_IFRAME_URL[FAILURE], { error }),
};
